import { delay, put } from "sagas/effects";

export function* timeSaga() {
  while (true) {
    yield delay(60 * 1000);
    yield put({ type: "SET_TIME", timeMs: Date.now() });
  }
}
